import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from "swiper";

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);
import "../../scss/layouts/blocks/swiper.scss";

export default () => {
	let swipers = document.querySelectorAll("[swiper]");

	swipers.forEach((sliderElement) => {
		let slides = sliderElement.getElementsByClassName("swiper-wrapper")[0].children;
		for (var i = 0; i < slides.length; i++) {
			slides[i].classList.add("swiper-slide");
		}
		let options = sliderElement.getAttribute("swiper");
		if (options) {
			try {
				options = JSON.parse(options);
			} catch (e) {
				console.log(e);
				alert(e);
			}
		}
		// Fade enabled
		if (options.effect && options.effect == "fade") {
			options.fadeEffect = {
				crossFade: true,
			};
		}
		// dynamic navigation

		// if (options.navigation) {
		//     options.navigation = {
		//         nextEl: ".dr-swiper-button-next",
		//         prevEl: ".dr-swiper-button-prev"
		//     }
		// }
		let swiperOptions = {
			speed: 500,
			spaceBetween: 250,
			pagination: {
				el: ".uk-slider-nav",
				bulletActiveClass: "uk-active",
				bulletClass: "uk-slider-bullet",
				modifierClass: "",
				clickable: true,
				renderBullet: (index, className) => {
					return '<li role="presentation" class="' + className + '"><a href="#" role="tab" aria-label="Slide ' + index + '" aria-controls="uk-slider-item-' + index + '" tabindex="-1"></a></li>';
				},
			},
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			...options,
		};
		if (swiperOptions.autoplay && swiperOptions.autoplay.delay) {
			document.querySelector(":root").style.setProperty("--swiper-autoplay-delay", swiperOptions.autoplay.delay + "ms");
		}
		new Swiper(sliderElement, swiperOptions);
	});
};
